let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3Z4fm")).then(() => parcelRequire('byL9G'));